/**
 * 收费域模块路由配置（门诊收费台 / 住院收费台）
 *
 * @module charging/routes
 */
import { RouteRecordRaw } from "vue-router";

const ChargingWorkbenchView = () =>
  import("./interfaces/ChargingWorkbenchView.vue");
const InpatientChargingView = () =>
  import("./interfaces/InpatientChargingView.vue");

export const chargingRoutes: RouteRecordRaw[] = [
  {
    path: "/charging",
    name: "ChargingWorkbench",
    component: ChargingWorkbenchView,
    meta: {
      title: "门诊收费工作站",
      requiresAuth: true,
      keepAlive: true,
      breadcrumb: ["首页", "门诊收费工作站"],
    },
  },
  {
    // 住院收费岗位站（P2）：独立页面，经工作站注册表 `inpatient_charging` 进入
    path: "/inpatient-charging",
    name: "InpatientChargingWorkbench",
    component: InpatientChargingView,
    meta: {
      title: "住院收费工作站",
      requiresAuth: true,
      keepAlive: false,
      breadcrumb: ["首页", "住院收费工作站"],
    },
  },
];

export default chargingRoutes;
